'use strict';

import $ from 'jquery';

import siteMenuTemplate from './menu.html';

export const siteMenuDirName = 'siteMenu';
export function siteMenuDir() {
  return {
    restrict: 'E',
    template: siteMenuTemplate,
    link: function(scope, element) {
      scope.isVisible = false;

      var everywhere = angular.element(window.document);

      everywhere.bind('click', ($e) => {
        let target = $e.target;

        if( target.classList.contains('hamburger') || target.parentElement && target.parentElement.classList.contains('hamburger') ) {
          scope.isVisible = !scope.isVisible;
        }
        else {
          scope.isVisible = false;
        }

        scope.$apply();
      });
    }
  }
};



// WEBPACK FOOTER //
// ./~/site_core/src/components/menu/menu.js